(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.updateStickyHeaderOffset = this.updateStickyHeaderOffset.bind(this);
    }

    updateStickyHeaderOffset() {
      const offset = Math.max(0, this.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--f-sticky-header-top', `${offset}px`);
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
        this.updateStickyHeaderOffset();
      } else {
        document.documentElement.style.setProperty('--f-sticky-header-top', '0px');
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
      window.addEventListener('scroll', this.updateStickyHeaderOffset, { passive: true });
      window.addEventListener('resize', this.updateStickyHeaderOffset);
      requestAnimationFrame(this.updateStickyHeaderOffset);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateStickyHeaderOffset);
      window.removeEventListener('resize', this.updateStickyHeaderOffset);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chillbee-kol-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.chillbeeKolVideoReady) return;
  window.chillbeeKolVideoReady = true;
  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest?.('a[data-kol-video-id]');
    if (trigger && event.key === ' ') {
      event.preventDefault();
      trigger.click();
    }
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-kol-video-id]');
    if (!trigger) return;
    const id = trigger.dataset.kolVideoId;
    if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
    event.preventDefault();
    const source = new URL(trigger.dataset.kolVideoUrl, window.location.origin);
    const time = source.searchParams.get('t') || source.searchParams.get('start') || '';
    const parts = time.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s?)?$/);
    const start = parts ? Number(parts[1] || 0) * 3600 + Number(parts[2] || 0) * 60 + Number(parts[3] || 0) : 0;
    const url = new URL('https://www.youtube.com/embed/' + id);
    url.searchParams.set('autoplay', '1');
    url.searchParams.set('playsinline', '1');
    url.searchParams.set('rel', '0');
    if (start) url.searchParams.set('start', String(start));
    const frame = document.createElement('iframe');
    frame.className = 'kol-reviews__preview-frame kol-reviews__player';
    frame.title = trigger.getAttribute('aria-label') || 'Watch review';
    frame.src = url.href;
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.tabIndex = 0;
    trigger.replaceWith(frame);
    frame.focus({ preventScroll: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
